import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import TechnologiesSection from "./components/TechnologiesSection";
import RealizationsSection from "./components/RealizationsSection";
import AppointmentSection from "./components/AppointmentSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import ChatBot from "./components/ChatBot";
import { Toaster } from "./components/ui/sonner";

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <TechnologiesSection />
      {/*<RealizationsSection />*/}
      <AppointmentSection />
      <ContactSection />
      <Footer />
      <ChatBot />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;